import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Container, Card } from 'react-bootstrap';

const API_URL = process.env.REACT_APP_API_URL;

function NewsDetail() {
  const { id } = useParams();
  const [newsArticle, setNewsArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNewsDetail = async () => {
      try {
        const response = await axios.get(`${API_URL}/news/${id}`); // Using environment variable
        setNewsArticle(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchNewsDetail();
  }, [id]);

  if (loading) {
    return <Container>Đang tải chi tiết tin tức...</Container>;
  }

  if (error) {
    return <Container>Lỗi: {error.message}</Container>;
  }

  if (!newsArticle) {
    return <Container>Không tìm thấy tin tức.</Container>;
  }

  return (
    <Container className="py-4">
      <Card className="border-0 shadow-sm animate-fade" style={{ borderRadius: '16px' }}>
        <Card.Body className="p-4 p-md-5">
          <h1 className="fw-bold mb-3">{newsArticle.title}</h1>
          <div className="text-muted small mb-4 pb-3 border-bottom">
            Đã đăng vào {new Date(newsArticle.created_at).toLocaleDateString("vi-VN", {
              day: '2-digit',
              month: 'long',
              year: 'numeric'
            })}
          </div>
          <div
            className="news-content"
            style={{ lineHeight: '1.8', fontSize: '1.1rem' }}
            dangerouslySetInnerHTML={{ __html: newsArticle.content }}
          />
        </Card.Body>
      </Card>
    </Container>
  );
}

export default NewsDetail;
